<ms-fixture-pick
    class="fixture-pick clearfix"
    trackingSource="RacePage/Antepost"
    *ngFor="let participant of vm.participants"
    [fixture]="vm.fixture"
    [participant]="participant"
    [option]="vm.options[participant.id]"
    title="{{ participant.name | msTranslate }}">
    <ms-antepost-container
        [vm]="vm"
        [participant]="participant"
        [crmPromotedOptionIdsMap]="crmPromotedOptionIdsMap"
        [isSports]="true"></ms-antepost-container>
</ms-fixture-pick>
